import { SEND_UPDATED_NOTIFICATION } from "../constants/actionTypes";
import { PENDING, SUCCESS, ERROR } from "../constants/status";

const initialState = {
  isLoading: false,
  successMessage: null,
  error: null,
};

export function accountNotificationReducer(state = initialState, action) {
  const { type, response } = action;

  switch (type) {
    case `${SEND_UPDATED_NOTIFICATION}_${PENDING}`:
      return {
        ...state,
        isLoading: true,
        successMessage: null,
        error: null,
      };

    case `${SEND_UPDATED_NOTIFICATION}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        successMessage: response?.data || "",
        error: null,
      };

    case `${SEND_UPDATED_NOTIFICATION}_${ERROR}`:
      return {
        ...state,
        isLoading: false,
        successMessage: null,
        error: response?.message || "",
      };

    default:
      return state;
  }
}
